export const illustrationMappings = [
  "Left Far Lateral",
  "Left Foraminal",
  "Left Paracentral",
  "Central",
  "Right Far Lateral",
  "Right Foraminal",
  "Right Paracentral",
]
